import {
  FETCHING_REPORT,
  FETCH_REPORT_SUCCESS,
  FETCHING_REPORTS_TEMPLATES,
  FETCH_REPORTS_TEMPLATES_SUCCESS,
  GENERATING_REPORT,
  GENERATE_REPORT_SUCCESS,
  DOWNLOADING_REPORT,
  DOWNLOAD_REPORT_SUCCESS
} from "./ReportConstants";

const initialState = {
  fetchingReports: false,
  fetchingReportsTemplate: false,
  generatingReport: false,
  deletingReport: false,
  downloadingReport: false,
  pageState: {
    page: 0,
    perPage: 10,
    totalEntries: 0,
    totalPages: 0
  },
  reports: [],
  reportsTemplates: []
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_REPORT:
      return { ...state, fetchingReports: true, pageState: {...initialState.pageState, page: action.pageState.page, perPage: action.pageState.perPage} };
    case FETCH_REPORT_SUCCESS:
      return { ...state, fetchingReports: false, reports: action.reports, pageState: action.pageState };
    case FETCHING_REPORTS_TEMPLATES:
      return { ...state, fetchingReportsTemplate: true };
    case FETCH_REPORTS_TEMPLATES_SUCCESS:
      return { ...state, fetchingReportsTemplate: false, reportsTemplates: action.reportsTemplates };
    case GENERATING_REPORT:
      return { ...state, generatingReport: true };
    case GENERATE_REPORT_SUCCESS:
      return { ...state, generatingReport: false};
    case DOWNLOADING_REPORT: 
      return {...state, downloadingReport: true};
    case DOWNLOAD_REPORT_SUCCESS:
      return {...state, downloadingReport: false};
    default:
      return state;
  }
};

export default reportReducer;


// WEBPACK FOOTER //
// ./src/redux/report/ReportReducer.js